import { render, staticRenderFns } from "./PromoteEmployee.vue?vue&type=template&id=64aa75b9"
import script from "./PromoteEmployee.vue?vue&type=script&lang=js"
export * from "./PromoteEmployee.vue?vue&type=script&lang=js"
import style0 from "./PromoteEmployee.vue?vue&type=style&index=0&id=64aa75b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports